import { Controller } from "remult";

@Controller("o-t-p-methods")
export class OTPMethods {}
